import { ComponentPropsWithoutRef, forwardRef, useId } from "react";
import styles from "./CheckBox.module.css";

export type CheckBoxProps = Omit<ComponentPropsWithoutRef<"input">, "type"> & {
  label?: string;
};

const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(({ label, ...rest }, ref) => {
  const id = rest.id ?? useId();

  return (
    <div className={styles.container}>
      <input ref={ref} {...rest} id={id} type="checkbox" />
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
});

export default CheckBox;
